// Case studies & product pages
import {cdnUrl} from '@/util/cdnImage';
import type {PageHeadMeta} from '@/components/PageHead';

export const BLOCKCHAIN_IN_HEALTHCARE_META_DATA: PageHeadMeta = {
    title: 'Blockchain in Healthcare: Building a Value-Based Healthcare Platform',
    description:
        'The best healthcare delivery app that uses blockchain & smart contracts to enable performance-based contracting, secure patient data, and better outcomes.'
};

export const FRIENDSPIRE_META_DATA: PageHeadMeta = {
    title: 'Friendspire | Entertainment Recommendation Solution',
    description:
        'Friendspire is a robust social recommendation app to find great movies, series, podcasts, and songs based on suggestions from your friends. Read the case study.'
};

export const IFINCA_META_DATA: PageHeadMeta = {
    title: 'iFinca | Coffee Supply Chain Solution | Debut Infotech',
    description:
        'iFinca is a blockchain-based coffee supply chain solution to track all processes from production to delivery with transparency, traceability, and profitability.'
};

export const INTEGRALEDGER_META_DATA: PageHeadMeta = {
    title: 'Integra ledger | Debut Infotech',
    description:
        'Utilize the Integra ledger, a Blockchain-powered digital signature tool for secure data sharing and enables seamless collaboration in all legal sectors.'
};

export const UNIQUESCHOOL_META_DATA: PageHeadMeta = {
    title: 'Unique School | Debut Infotech',
    description:
        'Unique School is an intelligent management platform to streamline administrative tasks, enhance communication, and improve security concerns.'
};

export const CIMET_META_DATA: PageHeadMeta = {
    title: 'Cimet | A Simplified Solution for Energy Retailers',
    description:
        'Cimet is a simplified comparison tool of Energy Retail Prices for different energy retailers to deliver value to customers and businesses alike.'
};

export const WELLPOP_META_DATA: PageHeadMeta = {
    title: 'WellPop | A Custom Healthcare Solution | Debut Infotech',
    img: cdnUrl('meta-images/Entertainment-banner-img.jpg'),
    description: `Read the Debut Infotech's WellPop case study and discover how we transformed digital health experiences with innovative tech solutions.`
};

export const CASE_STUDY_AI_META_DATA: PageHeadMeta = {
    title: 'TalentQuest Case Study: An AI-Powered Recruitment Solution',
    img: cdnUrl('talentQuest/candidate-search-bg.png'),
    description: `Discover how TalentQuest reshapes the recruitment industry with AI, enhancing accuracy and efficiency in hiring, in this insightful case study by Debut Infotech.`
};

export const CASE_STUDY_TITLETECH_META_DATA: PageHeadMeta = {
    title: 'TitleTech Financial Solution: A Case Study Of AI Automation',
    img: cdnUrl('meta-images/Entertainment-banner-img.jpg'),
    description: `Explore how our TitleTech Financial Solution transformed title insurance operations with advanced automation, boosting efficiency and accuracy.`
};

export const P2B_META_DATA = {
    title: 'P2B | Mining Industry App Development | Debut Infotech',
    img: cdnUrl('meta-images/Entertainment-banner-img.jpg'),
    description:
        'P2B (Performance to Business) is a SAAS-based product solution to streamline all processes in the mining industry. For more details, read our P2B case study.'
};

export const AITHENTIC_META_DATA: PageHeadMeta = {
    title: 'Aithentic | An IT Asset Management System | Debut Infotech',
    img: cdnUrl('meta-images/Entertainment-banner-img.jpg'),
    description:
        'Aithentic is an innovative solution for small and large enterprises to streamline the management processes of all IT assets used by businesses.'
};

export const EVERLEDGER_META_DATA: PageHeadMeta = {
    title: 'Everledger | Blockchain-Based Authentication Solution',
    description:
        'A Blockchain-Based Diamond Traceability Solution: An innovative blockchain-enabled solution for the end-to-end traceability of luxury goods.'
};

export const LUMMID_CONTAINER_META_DATA: PageHeadMeta = {
    title: 'Lummid Containers | Automated Inventory Management System',
    description:
        'Lummid utilised an Automated Inventory Management System to save time, reduce manual work, and accelerate sales, leveraging AI & ML, and real-time data.'
};

export const NDAX_ECOSYSTEM_META_DATA: PageHeadMeta = {
    title: 'NDAX | Crypto Suite for Secure Trading & Asset Management',
    description:
        'NDAX offers an enterprise‑ready crypto suite designed for secure trading and efficient asset management, helping businesses manage digital assets with confidence.'
};

export const PRC_META_DATA: PageHeadMeta = {
    title: 'PRC Coin Case Study: A Real Estate ICO & Exchange Platform',
    img: cdnUrl('PRC-case-study/PRC-banner.jpg'),
    description:
        'Explore how we built PRC Coin — a compliant blockchain ICO and exchange solution on BNB chain, featuring smart contracts, KYC compliance, and fiat integration.'
};

export const DRAWPOST_META_DATA: PageHeadMeta = {
    title: 'Drawpost Case Study: An Exclusive AI SMM Automation Platform',
    img: cdnUrl('drawpost-case-study/Drawpost-ai-powered-marketing-platform-banner.webp'),
    description:
        'Drawpost by Debut Infotech is an AI-Powered Social Media Marketing Automation Platform that streamlines content planning, creation, and publishing for businesses and agencies.'
};
